import type { EstimateStatus, POStatus } from '@billflow/shared';
import type { CountertopJobStatusUI } from '@/lib/api-types';

// ─── Estimate status badge map ──────────────────────────────────────────────────

export const ESTIMATE_STATUS_BADGE: Record<
  EstimateStatus,
  { variant: 'gray' | 'blue' | 'amber' | 'green' | 'red'; label: string }
> = {
  draft: { variant: 'gray', label: 'Draft' },
  issued: { variant: 'blue', label: 'Issued' },
  partial: { variant: 'amber', label: 'Partial' },
  paid: { variant: 'green', label: 'Paid' },
  returned: { variant: 'red', label: 'Returned' },
};

// ─── Purchase order status badge map ───────────────────────────────────────────

export const PO_STATUS_BADGE: Record<
  POStatus,
  { variant: 'gray' | 'blue' | 'green' | 'amber' | 'red'; label: string }
> = {
  draft: { variant: 'gray', label: 'Draft' },
  sent: { variant: 'blue', label: 'Sent' },
  received: { variant: 'green', label: 'Received' },
  returned: { variant: 'amber', label: 'Returned' },
  cancelled: { variant: 'red', label: 'Cancelled' },
};

// ─── Sales/purchase return status badge map ─────────────────────────────────────

export const RETURN_STATUS_BADGE: Record<
  'open' | 'refunded',
  { variant: 'amber' | 'green'; label: string }
> = {
  open: { variant: 'amber', label: 'Open' },
  refunded: { variant: 'green', label: 'Refunded' },
};

// ─── Countertop job status badge map (countertop_jobs.status) ───────────────────

export const COUNTERTOP_JOB_STATUS_BADGE: Record<
  CountertopJobStatusUI,
  { variant: 'gray' | 'blue' | 'amber' | 'yellow' | 'green' | 'red'; label: string }
> = {
  inquiry: { variant: 'gray', label: 'Inquiry' },
  quoted: { variant: 'blue', label: 'Quoted' },
  advance_paid: { variant: 'amber', label: 'Advance Paid' },
  measured: { variant: 'yellow', label: 'Measured' },
  ordered: { variant: 'blue', label: 'Ordered' },
  installing: { variant: 'blue', label: 'Installing' },
  installed: { variant: 'green', label: 'Installed' },
  cancelled: { variant: 'red', label: 'Cancelled' },
};

// ─── Pickup status badge map (estimates.pickup_status) ──────────────────────────

export type PickupStatus = 'na' | 'awaiting' | 'partial' | 'complete';

export const PICKUP_STATUS_BADGE: Record<
  PickupStatus,
  { variant: 'gray' | 'amber' | 'blue' | 'green'; label: string }
> = {
  na: { variant: 'gray', label: 'No Pickup' },
  awaiting: { variant: 'amber', label: 'Awaiting Pickup' },
  partial: { variant: 'blue', label: 'Partial Pickup' },
  complete: { variant: 'green', label: 'Picked Up' },
};
